import { render } from "./ElementsPagination.vue?vue&type=template&id=55935341&scoped=true"
import script from "./ElementsPagination.vue?vue&type=script&lang=js"
export * from "./ElementsPagination.vue?vue&type=script&lang=js"

import "./ElementsPagination.vue?vue&type=style&index=0&id=55935341&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55935341"]])

export default __exports__